import keyMirror from "ramda-extension/es/keyMirror";
export const tabVariants = keyMirror({
    BASIC: null,
    PANEL: null
});
